import { render, staticRenderFns } from "./InputfieldLabel.vue?vue&type=template&id=3c2fdd65&scoped=true&"
import script from "./InputfieldLabel.vue?vue&type=script&lang=js&"
export * from "./InputfieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2fdd65",
  null
  
)

export default component.exports